import {TypeInt} from './../TypeDefinition'

import ParseExpression from './ParseExpression.js'
import ParseSentences from './ParseSentences.js'

function ParseSentenceSelect (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
}

ParseSentenceSelect.prototype = {
    parse () {
        let anotherConstant
        let selectVarDispl
        let selectToken
        let expType
        let exitBranch = null
        let endJumps = []
        let enterBranches
        let expectedToken
        let isNegative = false
        let constantToken
        let parseExpression = new ParseExpression(this.parser)
        let parseSentences = new ParseSentences(this.parser)

        selectToken = this.parser.expect(this.SC.K_SELECT)

        if (this.parser.compile) {
            selectVarDispl = this.stable.getCurrentDisplacement()
            this.pcode.push(TypeInt(), 1, selectToken)
            this.stable.incrementDisplacement(1)
        }

        expType = parseExpression.parse()
        if (!expType.isInt()) {
            this.parser.error(selectToken, 'La expresión debe ser de tipo Entero.')
        }

        if (this.parser.compile) {
            selectToken.procName = this.parser.currentProcName
            this.pcode.store(TypeInt(), selectVarDispl, selectToken)
        }

        expectedToken = this.parser.expect(this.SC.K_DO)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_DO])
        }

        while (this.scanner.nextIsIn([this.SC.CONS_INT, this.SC.SUB])) {
            enterBranches = []
            if (this.parser.compile && exitBranch !== null) {
                exitBranch.op1 = this.pcode.instructionCount() + 1
            }
            anotherConstant = true
            while (anotherConstant) {
                anotherConstant = false

                if (this.scanner.nextIs(this.SC.SUB)) {
                    this.scanner.consume()
                    isNegative = true
                } else {
                    isNegative = false
                }
                constantToken = this.parser.expect(this.SC.CONS_INT)
                selectToken.line = constantToken.line
                selectToken.column = constantToken.column
                if (this.parser.compile) {
                    this.pcode.load(TypeInt(), selectVarDispl, selectToken)
                }

                if (constantToken !== false) {
                    if (this.parser.compile) {
                        if (isNegative) {
                            this.pcode.ldcons(TypeInt(), constantToken.lexema.times(-1), constantToken)
                        } else {
                            this.pcode.ldcons(TypeInt(), constantToken.lexema, constantToken)
                        }
                    }
                }

                if (this.scanner.nextIs(this.SC.COMMA)) {
                    anotherConstant = true
                    this.scanner.consume()

                    if (this.parser.compile) {
                        this.pcode.neq(constantToken)
                        enterBranches.push(this.pcode.branch(0, constantToken))
                    }
                } else {
                    if (this.parser.compile) {
                        this.pcode.eq(constantToken)
                        exitBranch = this.pcode.branch(0, constantToken)
                    }
                }
            }

            expectedToken = this.parser.expect(this.SC.COLON)

            if (this.parser.compile) {
                for (let b of enterBranches) {
                    b.op1 = this.pcode.instructionCount() + 1
                }
            }

            parseSentences.parse()

            if (this.parser.compile) {
                endJumps.push(this.pcode.jump(0, this.scanner.next()))
            }
        }

        if (this.parser.compile && exitBranch !== null) {
            exitBranch.op1 = this.pcode.instructionCount() + 1
        }

        if (this.hintHelper) {
            this.hintHelper.checkTokensForHints([this.SC.K_OTHERWISE])
        }
        if (this.scanner.nextIs(this.SC.K_OTHERWISE)) {
            this.parser.expect(this.SC.K_OTHERWISE)
            this.parser.expect(this.SC.COLON)
            parseSentences.parse()
        }

        expectedToken = this.parser.expect(this.SC.K_END_SELECT)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_END_SELECT], '\n')
        }
        if (this.parser.compile) {
            for (let jump of endJumps) {
                jump.op1 = this.pcode.instructionCount() + 1
                this.pcode.setToken(jump, expectedToken)
            }
            this.pcode.pop(TypeInt(), 1, expectedToken)
            this.stable.incrementDisplacement(-1)
        }
    }
}

export default ParseSentenceSelect



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentenceSelect.js